import React from 'react'
import PropTypes from 'prop-types'

const CommentLabelDropdown = ({ labels, selectedValue, onChange, type }) => {
  const commentLabels = labels.map(function (label, index) {
    return (
      <option value={label} key={index}>
        {label}
      </option>
    )
  })

  return (
    <select
      className="aDropdown"
      id={`commentLabel${type}`}
      defaultValue={selectedValue}
      onChange={onChange}
    >
      {commentLabels}
    </select>
  )
}

CommentLabelDropdown.propTypes = {
  labels: PropTypes.array,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string
}

export default CommentLabelDropdown



// WEBPACK FOOTER //
// ./src/components/mini/comments/CommentLabelDropdown.js